
<div mat-dialog-title>Cost Basis Could Not Be Confirmed<button class="close" mat-button data-cancel-button title="Cancel" (click)="close()">
  <i class="material-icons clear">clear</i>
</button></div>
<mat-dialog-content>
  <mat-card class="block warn">
    <mat-card-title style="white-space: pre-line;" data-portfolio-name>
      <strong>Portfolio: {{portfolioName}}</strong>
    </mat-card-title>
  </mat-card>
  @if (data.lotMismatchList) {
    <div style="padding: 0 5px;" data-mismatched-lots-warning>
      Cost basis could not be confirmed for the holdings listed below, possibly as a
      result of a recent trade that is not yet reflected in the underlying tax lot information. For purposes of this
      rebalance, iRebal has assumed a single lot for these positions with no gain or loss. You may wish to check your
      records to determine the gain or loss
      impact of executing the proposed orders before approving, or wait until the information is updated and run the
      rebalance again.
    </div>
  }
  @if (data.lotMissingCostBasisList) {
    <div style="padding: 0 5px;" data-missing-lots-warning>The holdings listed below have
      a zero (0) cost basis, so the cost basis for the lot in
      question was set equal to the lots market value. As a result, no gain / loss was calculated for these tax lots.
      You can enter cost basis for the position on Schwab Advisor Center and rerun the analysis for a more accurate calculation of
      gain/loss for this position.
    </div>
  }
  <irb-inventory-grid id="dialog-pr-cost-basis-grid"
    [style.width] = "'100%'"
    [style.height] = "gridHeight"
    [showSideBar] = "false"
    [gridOptions] = "gridOptions"
  (gridReady) = "onGridReady($event)"></irb-inventory-grid>

</mat-dialog-content>
<mat-dialog-actions>
  <button data-close-button (click)="close()" class="btn-medium-primary">Close</button>
</mat-dialog-actions>
